import {
    EntityType,
    GroupRideGroupContract,
    GroupRideGroupCreateContract,
} from '@polaris-customerweb/sharedcomponents.core';
import { cloneDeep } from 'lodash-es';
import { RideGroupRider } from './ride-group-rider';

export class RideGroup {
    type: EntityType = 'RideGroup';

    private raw: GroupRideGroupContract;

    constructor(dto: GroupRideGroupContract = {}) {
        this.raw = cloneDeep(dto);
    }

    get groupId(): string {
        return this.raw.id || '';
    }

    get id(): string {
        return this.raw.id || '';
    }

    get inviteUrl(): string {
        return this.raw.inviteUrl || '';
    }

    get isCurrentRiderInGroup(): boolean {
        return this.raw.isCurrentRiderInGroup || false;
    }
    set isCurrentRiderInGroup(isInGroup: boolean) {
        this.raw.isCurrentRiderInGroup = isInGroup;
    }

    get isPrivate(): boolean {
        return this.raw.isPrivate || false;
    }

    get name(): string {
        return this.raw.name || '';
    }

    get riders(): RideGroupRider[] {
        //NOTE: May cause digestion loop
        return (this.raw.riders || []).map((r) => new RideGroupRider(r));
    }

    get size(): number {
        return this.raw.size || 0;
    }

    get closestRiderDistance(): number | undefined {
        return this.raw.closestRiderDistance;
    }

    get furthestRiderDistance(): number | undefined {
        return this.raw.furthestRiderDistance;
    }

    clone(): RideGroup {
        const rideGroup = new RideGroup(this.toContract());
        return rideGroup;
    }

    toCreateContract(): GroupRideGroupCreateContract {
        return {
            id: this.groupId,
            isPrivate: this.isPrivate,
            name: this.name,
        };
    }

    toContract(): GroupRideGroupContract {
        return cloneDeep(this.raw);
    }
}
